import { Injectable } from '@angular/core';
import { HotToastService, ToastPosition } from '@ngneat/hot-toast';
import tinymce, { Editor } from 'tinymce';

@Injectable({
    providedIn: 'root',
})
export class UtilService {
    isMapLoad: boolean = false;
    scriptAddData: any;
    currentToast: any;
    isEditorLoaded: any = [];
    constructor(
        private toast: HotToastService,
    ) { }

    showToast(msg: string, isErr?: boolean, isDuration = 5000) {
        let options = {
            duration: isDuration,
            position: 'top-right' as ToastPosition,
            style: {
                'overflow-wrap': 'break-word',
                'word-break': 'break-word',
                'white-space': 'normal',
                'padding': '8px'
            },
            dangerouslyUseHTMLString: true
        };
        const parsedMessage = this.parseMessageWithLinks(msg);
        if (isErr) {
            this.toast.error(parsedMessage, options);
        } else {
            this.toast.success(parsedMessage, options);
        }
    }
    

    parseMessageWithLinks(msg: string): string {
        console.log({msg});
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        return msg.replace(urlRegex, (url) => `<a href="${url}" target="_blank" class="custom-toast-link">${url}</a>`);
    }

    hexToRgb(hex) {
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? parseInt(result[1], 16) +
            ',' +
            parseInt(result[2], 16) +
            ',' +
            parseInt(result[3], 16)
            : null;
    }

    setTinyMCEContent(content, editor_id = 'conversation_editor', is_focus = true) {
        console.log('content', content, editor_id);
        let intervalId: any;
        intervalId = setInterval(() => {
            if (this.isEditorLoaded.includes(editor_id)) {
                if (tinymce && tinymce.Editor) {
                    const editor = tinymce.get(editor_id);
                    if (editor) {
                        clearInterval(intervalId);
                        editor.setContent(content ? content : '');
                        if(is_focus) {
                            this.focusTinyEditor(editor_id);
                        }
                    }
                }
            }
        }, 100);
    }
    
    focusTinyEditor(editor_id) {
        console.log({focusEditor: editor_id});
        if (tinymce && tinymce.activeEditor && tinymce.get(editor_id)) {
            let editor: Editor = tinymce.get(editor_id);
            if(editor && editor.getBody()) {
                var endNode = editor.getBody().lastChild;
                var range = editor.selection.getRng();
                if(range) {
                    range.setStartAfter(endNode);
                    range.collapse(true);
                    editor.selection.setRng(range);
                    editor.focus();
                }
            }
        }
    }
    
    
    destroyTinyMCEEditor() {
        if (tinymce && tinymce.Editor) {
            this.isEditorLoaded = [];
            tinymce.remove();
        }
    }

    changeEditorMode(isDesign?) {
        tinymce.activeEditor.mode.set(isDesign ? 'design' : 'readonly');
    }

    deepCopy(data) {
        try {
            return JSON.parse(JSON.stringify(data));
        } catch (error) {
            return data;
        }
      }
    
}
